import { useDsTranslateMessage } from '@mc/wink/internationalization/useDsTranslateMessage';

// Translation for FileInput default values
export const TranslateFileInput = (
  maxFiles: number,
  allowedExtensions: string,
  readableMaxFileSize: string,
) => {
  return {
    errorMsg: useDsTranslateMessage({
      id: 'mcds.fileInput.error_text',
      defaultMessage: 'Error',
    }),
    removeFileMsg: useDsTranslateMessage({
      id: 'mcds.fileInput.remove_file_text',
      defaultMessage: 'Remove file',
    }),
    addFileMsg: useDsTranslateMessage({
      id: 'mcds.fileInput.add_file_text',
      defaultMessage: 'Add file',
    }),
    addFilesMsg: useDsTranslateMessage({
      id: 'mcds.fileInput.add_files_text',
      defaultMessage: 'Add files',
    }),
    dragAndDropLabel: useDsTranslateMessage({
      id: 'mcds.fileInput.drag_and_drop_label',
      defaultMessage: 'Drop files here to upload',
    }),
    errorRedesignTitle: useDsTranslateMessage({
      id: 'mcds.redesign.fileInput.error_text',
      defaultMessage: 'There was an issue uploading your file',
    }),
    errorRedesignMaxFileSingluar: useDsTranslateMessage({
      id: 'mcds.redesign.fileInput.max_files_singluar',
      defaultMessage: `You've reached the file limit. You can only upload {maxFiles} file.`,
      values: { maxFiles: maxFiles },
    }),
    errorRedesignMaxFilePlural: useDsTranslateMessage({
      id: 'mcds.redesign.fileInput.max_files_plural',
      defaultMessage: `You've reached the file limit. You can only upload {maxFiles} files.`,
      values: { maxFiles: maxFiles },
    }),
    errorRedesignDuplicateFiles: useDsTranslateMessage({
      id: 'mcds.redesign.fileInput.duplicate_files',
      defaultMessage: ` has already been uploaded`,
    }),
    errorRedesignServerError: useDsTranslateMessage({
      id: 'mcds.redesign.fileInput.server_error',
      defaultMessage: `Something went wrong uploading your file.`,
    }),
    errorRedesignFileType: useDsTranslateMessage({
      id: 'mcds.redesign.fileInput.file_type',
      defaultMessage: ` isn’t supported. Upload a {allowedExtensions} file.`,
      values: { allowedExtensions: allowedExtensions },
    }),
    errorRedesignFileSize: useDsTranslateMessage({
      id: 'mcds.redesign.fileInput.file_size',
      defaultMessage: `  is too big. Files must be less than {readableMaxFileSize}.`,
      values: { readableMaxFileSize: readableMaxFileSize },
    }),
  };
};
